import React from 'react';

const IconButton = ({ Icon, onClick, spin = false, title, fixedWidth = false, className = '' }) => (
  <button type="button" className={`btn px-1 ${className}`} onClick={onClick} title={title} aria-label={title}>
    <Icon spin={spin} title={title} fixedWidth={fixedWidth} aria-hidden="true" />
  </button>
);

export default IconButton;
